const ADD_GUIDED_INTAKE_BASE_URL =
  'https://www.procurify.com/add-guided-intake/'

export const buildGuidedIntakeContactSalesUrl = ({
  domain,
  email,
}: {
  domain: string
  email: string
}): string => {
  const params = new URLSearchParams({
    utm_domain: domain,
    utm_email: email,
  })
  return `${ADD_GUIDED_INTAKE_BASE_URL}?${params.toString()}`
}
